import { createContext } from "react";
import { API } from "../api";

export const ApiContext = createContext(API);
